import { useEffect } from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";

const WithoutPagination = ({
  data,
  columns,
  pageSize = 5,
  loading,
  enableRowSelection,
  ...others
}) => {
  const table = useMaterialReactTable({
    columns,
    data,
    enableColumnResizing: true,
    enableColumnActions: true,
    enableRowActions: true,
    positionActionsColumn: "last",
    enableDensityToggle: false,
    enableRowSelection: enableRowSelection || false,
    enableFullScreenToggle: false,
    enableStickyHeader: true,
    layoutMode: "grid",
    displayColumnDefOptions: { "mrt-row-actions": { size: 90 } },
    // rowPinningDisplayMode: 'select-sticky',
    //  enableGrouping:true,
    initialState: {
      density: "comfortable",
      // isLoading: loading,
      columnPinning: { left: [], right: ["mrt-row-actions"] },
    },
    state: {
      showSkeletons: loading,
      showProgressBars: loading,
      // isLoading: loading,
    },
    muiTableHeadRowProps: {
      sx: {
        background: theme =>
          theme.palette.mode === "light"
            ? theme.palette.grey[200]
            : theme.palette.grey[700],
      },
    },
    muiTableHeadCellProps: {
      sx: {
        color: theme =>
          theme.palette.mode === "light"
            ? theme.palette.grey[600]
            : theme.palette.grey[200],
        paddingLeft: "4px",
        paddingRight: "8px",
        boxShadow: "none",
        background: theme =>
          `${
            theme.palette.mode === "light"
              ? theme.palette.grey[200]
              : theme.palette.grey[700]
          }  !important`,
        fontWeight: 600,
        "& .Mui-TableHeadCell-Content": {
          justifyContent: "space-between",
        },
      },
    },
    muiTableBodyCellProps: {
      sx: {
        paddingLeft: "4px",
        paddingRight: "8px",
        boxShadow: "none",
      },
    },
    muiTableContainerProps: { 
      sx: {
        maxHeight: "none", 
        // overflow: "visible", 
      },
    },
    muiTableHeadCellColumnActionsButtonProps: {
      sx: {
        color: theme => theme.palette.primary.contrastText,
        opacity: 1,
      },
    },
    muiTableBodyRowProps: {
      sx: {
        "&.MuiTableRow-root.Mui-selected .MuiTableCell-body": {
          background: theme => theme.palette.primary.lighter,
          color: "black",
        },
      },
    },
    // muiSelectCheckboxProps:{color:'secondary'},
    // muiTableContainerProps: { sx: { maxHeight: "500px" } },
    ...others,
  });

  useEffect(() => {
    table.resetRowSelection();
  }, [data, table]);
  return <MaterialReactTable table={table} />;
};

export default WithoutPagination;
